import "./LiveDot.css";

/**
 * LiveDot — indicador "en vivo" con splash/ripple expansivo.
 *
 * Pixel-perfect con Loaders.html mock:
 *   ::before = anillo translúcido que escala 1 → 2.4 y fade out (splash).
 *   ::after  = dot sólido siempre encima.
 *   timing:   cubic-bezier(0, 0, 0.2, 1), 1.8s infinite.
 *
 * Semántica: dot = estado estable, splash = actividad. NO usar para loading
 * (eso es `<Spinner />`).
 *
 * Color via Tailwind `text-{color}` consumiendo `currentColor`.
 *
 * @param {object} props
 * @param {number}  [props.size=10]
 * @param {"success"|"danger"|"info"|"warning"|"role-master"|"muted"} [props.color="success"]
 * @param {boolean} [props.animate=true]     Si false: dot estático (offline).
 * @param {string}  [props.label="En vivo"]
 * @param {string}  [props.className]
 */
// Los dos últimos existen para los estados administrativos del vehículo
// (`utils/deviceStateStyles.js`): sin ellos, mantenimiento caía en `warning` —
// el ámbar de "detenido"— y volvía a leerse como un estado operativo.
const COLOR_CLASS = {
  success: "text-success",
  danger: "text-danger",
  info: "text-info",
  warning: "text-warning",
  "role-master": "text-role-master-soft",
  muted: "text-text-dim",
};

export function LiveDot({
  size = 10,
  color = "success",
  animate = true,
  label = "En vivo",
  className = "",
  ...rest
}) {
  const hasColorOverride = /\btext-/.test(className);
  const colorClass = hasColorOverride
    ? ""
    : (COLOR_CLASS[color] ?? COLOR_CLASS.success);
  const animClass = animate ? "live-dot-animated" : "";
  return (
    <span
      role="status"
      aria-label={label}
      className={`live-dot ${animClass} ${colorClass} ${className}`.trim()}
      style={{ width: `${size}px`, height: `${size}px` }}
      {...rest}
    />
  );
}

export default LiveDot;
